<template>
  <!-- Our promise (S2_Proof): a boxed list of what you can count on. -->
  <SectionBand :variant="variant" :background="section.background" label="Our promise">
    <div class="s2-promise" :class="{'t-card': layout === 'box'}" :data-layout="layout">
      <span v-if="layout === 'box'" class="s2-promise__mark" aria-hidden="true">✓</span>
      <component :is="headingTag" class="t-h2">{{ section.heading || 'Our promise' }}</component>
      <ul class="mo-stagger">
        <li v-for="(it, i) in items" :key="i"><span aria-hidden="true" class="s2-tick">✓</span><span><strong v-if="it.title">{{ it.title }}</strong><template v-if="it.title && it.text"> — </template>{{ it.text }}</span></li>
      </ul>
    </div>
  </SectionBand>
</template>

<script setup>
import {useSectionHeadingTag} from "@/composables/useSectionHeadingTag.js";
import {computed} from "vue";
import SectionBand from "../shared/SectionBand.vue";
const headingTag = useSectionHeadingTag();

const props = defineProps({section: {type: Object, required: true}, variant: {type: [Number, String], default: 1}});
const layout = computed(() => (props.section.layout === "list" ? "list" : "box"));
const items = computed(() => (Array.isArray(props.section.items) ? props.section.items : [])
  .map((it) => (typeof it === "string" ? {title: "", text: it} : {title: it?.title || "", text: it?.text || ""}))
  .filter((it) => it.title || it.text));
</script>

<style scoped>
.s2-promise[data-layout="box"] { max-width: 40rem; padding: clamp(1.5rem, 4vw, 2.5rem); border: 2px solid var(--t-accent); }
.s2-promise__mark { display: inline-flex; width: 2.6rem; height: 2.6rem; border-radius: 999px; align-items: center; justify-content: center; border: 2px solid var(--t-accent); color: var(--t-accent); font-weight: 800; margin-bottom: .75rem; }
.s2-promise ul { list-style: none; padding: 0; margin: 1rem 0 0; display: grid; gap: .6rem; }
.s2-promise li { display: flex; gap: .6rem; align-items: baseline; line-height: 1.5; }
.s2-tick { color: var(--t-accent); font-weight: 800; }
</style>
